import * as angular from "angular";
import * as _ from "lodash";
import {ClusteringAreaModel} from "../models/clustering-area.model";

export class PlanningClusteringAreasRequestsService {

  /* @ngInject */
  constructor(private PlanningAPI, private PlanningProjectsAPI, private PlanningDraftsAPI,
              private $planning, private $planningProjects, private $drafts, private $q) {
  }

  queryClusteringAreas(ownerId: string, limit?: number, cursor?: string) {
    const api = this.PlanningAPI.actions.queryClusteringAreas;
    const params: any = {ownerId: ownerId};
    if (typeof limit === 'number') {
      params.limit = limit;
    }
    if (cursor) {
      params.cursor = cursor;
    }
    return this.call(api, params, {}, {});
  }

  getClusteringAreasByIds(ownerId: string, areaIds: string[]) {
    const api = this.PlanningAPI.actions.getClusteringAreasByIds;
    return this.call(api, {ownerId: ownerId, areaIds: areaIds}, {}, {});
  }

  getClusteringAreasForMap(ownerId: string, areaIds: string[]) {
    if (!ownerId || !areaIds?.length) {
      return this.$q.when([]);
    }

    return this.getClusteringAreasByIds(ownerId, areaIds)
      .then((response) => this.normalizeClusteringAreasResponse(response));
  }

  normalizeClusteringAreasResponse(response): ClusteringAreaModel[] {
    let areas: ClusteringAreaModel[] = [];

    if (_.isArray(response)) {
      areas = response;
    } else if (_.isArray(response?.list)) {
      areas = response.list;
    } else if (_.isArray(response?.clusteringAreas)) {
      areas = response.clusteringAreas;
    }

    return _.map(areas, (area) => this.normalizeClusteringArea(area));
  }

  normalizeClusteringArea(area: ClusteringAreaModel): ClusteringAreaModel {
    if (!area) {
      return area;
    }

    const serviceAreaName = area.serviceAreaName || area.areaReference?.name;

    return {
      ...area,
      serviceAreaId: area.serviceAreaId || area.areaReference?.id,
      serviceAreaName: serviceAreaName,
      name: area.name || serviceAreaName
    };
  }

  normalizeClusteringAreaFromEdit(response, editedArea: ClusteringAreaModel): ClusteringAreaModel {
    const merged = response?.id === editedArea?.id ? {...editedArea, ...response} : editedArea;
    return this.normalizeClusteringArea(merged);
  }

  syncClusteringAreas(ownerId: string) {
    const api = this.PlanningAPI.actions.syncClusteringAreas;
    return this.call(api, {ownerId: ownerId}, {}, {});
  }

  editClusteringArea(clusteringAreaId: string, clusteringArea: ClusteringAreaModel) {
    const api = this.PlanningAPI.actions.editClusteringArea;
    return this.call(api, {}, clusteringArea, {clusteringAreaId: clusteringAreaId});
  }

  addClusteringAreasToTemplate(templateId: string, areaIds: string[]) {
    const api = this.PlanningAPI.actions.addClusteringAreaToTemplate;
    return this.call(api, {areaId: areaIds}, {}, {id: templateId});
  }

  removeClusteringAreaFromTemplate(templateId: string, areaId: string) {
    const api = this.PlanningAPI.actions.removeClusteringAreaFromTemplate;
    return this.call(api, {areaId: areaId}, {}, {id: templateId});
  }

  addClusteringAreasToProject(projectId: string, areaIds: string[]) {
    const api = this.PlanningProjectsAPI.actions.addClusteringAreaToProject;
    return this.callProjects(api, {areaId: areaIds}, {}, {id: projectId});
  }

  removeClusteringAreaFromProject(projectId: string, areaId: string) {
    const api = this.PlanningProjectsAPI.actions.removeClusteringAreaFromProject;
    return this.callProjects(api, {areaId: areaId}, {}, {id: projectId});
  }

  addClusteringAreasToDraft(projectId: string, draftId: string, areaIds: string[]) {
    const api = this.PlanningDraftsAPI.actions.addClusteringAreaToDraft;
    return this.callDrafts(api, {areaId: areaIds}, {}, {projectId: projectId, draftId: draftId});
  }

  removeClusteringAreaFromDraft(projectId: string, draftId: string, areaId: string) {
    const api = this.PlanningDraftsAPI.actions.removeClusteringAreaFromDraft;
    return this.callDrafts(api, {areaId: areaId}, {}, {projectId: projectId, draftId: draftId});
  }

  private call(_apiCall, _params, _data, _options) {
    return this.$planning().$call(_apiCall, _params, _data, _options);
  }

  private callProjects(_apiCall, _params, _data, _options) {
    return this.$planningProjects().$call(_apiCall, _params, _data, _options);
  }

  private callDrafts(_apiCall, _params, _data, _options) {
    return this.$drafts().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.planning')
  .service('planningClusteringAreasRequestsService', PlanningClusteringAreasRequestsService);
